<div *ngFor="let treatment of treatmentData" class="treatment-detail">
  <p>
    <strong>Date Created:</strong>
    {{ treatment?.date_created | date : "medium" }}
  </p>
  <p>
    <strong>Provisional Diagnosis:</strong>
    {{ treatment?.provisional_diagnosis || "N/A" }}
  </p>

  <div
    *ngIf="
      treatment?.treatment_plan && treatment?.treatment_plan?.length > 0;
      else noTreatmentPlan
    "
    class="treatment-plan"
  >
    <h3>Treatment Plan</h3>
    <div
      class="treatment-plan-block"
      *ngFor="let plan of treatment?.treatment_plan"
    >
      <p>
        <strong>Concern Details:</strong> {{ plan?.concerns_details || "N/A" }}
      </p>
      <div
        *ngIf="
          plan?.interventions_details && plan?.interventions_details?.length > 0
        "
      >
        <ul>
          <li *ngFor="let intervention of plan?.interventions_details">
            <strong>Intervention:</strong>
            {{ intervention?.intervention || "No intervention details" }}
          </li>
        </ul>
      </div>
      <p><strong>Status:</strong> {{ plan?.status || "N/A" }}</p>
      <p>
        <strong>Target Name:</strong>
        {{ getCommaSeparatedTargets(plan?.target_name) }}
      </p>
    </div>
  </div>

  <ng-template #noTreatmentPlan>
    <p class="else-message">
      No treatment details found or you have saved an empty form.
    </p>
  </ng-template>
</div>
